import { createApiRequestType, strictObjectAccess } from '@ackee/redux-utils';
import { EntityKey } from 'constants/index';

const apiRequestType = createApiRequestType({
    modulePrefix: EntityKey.CLOSED_INCIDENTS,
});
export const fetchClosedIncidentsTypes = strictObjectAccess({ ...apiRequestType({ typePrefix: 'FETCH_CLOSED_INCIDENTS_' }) });
